// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function onDelete(action: any, msg = 'Do you really want to do this?') {
  if (window.confirm(msg)) {
    // eslint-disable-line no-alert
    action();
  }
}
